<form class="form-container" [formGroup]="form">
    <h3 mat-dialog-title>{{ 'REOPEN_COMPLAINT' | translate }}</h3>
    <mat-dialog-content class="mat-typography">

        <div class="row">
            <div class="col-12 text-center">
                <mat-label>{{ 'REOPEN_CONFIRMATION_TEXT' | translate }}</mat-label>
            </div>
            <div class="col-12">
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'COMMENTS' | translate }} </mat-label>
                    <textarea matInput formControlName="comment"></textarea>
                </mat-form-field>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
            <button mat-raised-button [disabled]="form.invalid" (click)="save()" color="primary"
                    cdkFocusInitial>{{ 'SAVE' | translate }} </button>
            <button mat-raised-button mat-dialog-close>{{ 'CANCEL' | translate }}</button>
    </mat-dialog-actions>
</form>
